import { BaseStore } from 'core/base-store';
import { SequenceRepository } from 'core/sequence.repository';
import { catchError, first, from, map, of } from 'rxjs';

import { UiService } from '../../../../../core/services/ui.services';
import ProductCache from '../../../services/product.cache';
import { Product } from './product.model';
import ProductRepository from './product.repository';

const itemInit: Product = new Product('');
type IState = {
  products: Product[];
};
const stateInit: IState = {
  products: [],
};

export class ProductStore extends BaseStore<IState, Product> {
  get sequenceName() {
    return this.repository.collectionName + '-productCode';
  }
  seed = 1022;
  constructor(
    uiService: UiService,
    private sequence: SequenceRepository,
    private repository: ProductRepository,
    private productCache: ProductCache,
  ) {
    super(uiService, stateInit, itemInit);
  }

  loadList() {
    this.ui.loader.show();
    from(this.repository.getAllOrderByProductName())
      .pipe(
        catchError(() => of([] as Product[])),
        map(products => {
          this._state.next({ products });
          this.ui.loader.hide();
        }),
        first(),
      )
      .subscribe();
  }

  async save() {
    try {
      const model = this.current;
      const entity = Product.build(model);
      if (!entity.id) {
        entity.productCode = await this.sequence.next(this.sequenceName, this.seed);
        await this.repository.add(entity);
      } else {
        if (!entity.productCode)
          entity.productCode = await this.sequence.next(this.sequenceName, this.seed);
        await this.repository.update(entity.id, entity);
      }
      this.ui.modal.close();
      this.productCache.invalidate();
      this.loadList();
    } catch (e: any) {
      this.showValidationMessage(e.message);
    }
  }

  delete(id: string) {
    this.repository.delete(id);
    this.loadList();
  }
}
